import { render, staticRenderFns } from "./AffinityDNA.vue?vue&type=template&id=f939a81a&scoped=true"
import script from "./AffinityDNA.vue?vue&type=script&lang=js"
export * from "./AffinityDNA.vue?vue&type=script&lang=js"
import style0 from "./AffinityDNA.vue?vue&type=style&index=0&id=f939a81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f939a81a",
  null
  
)

export default component.exports